import { useSelector } from 'react-redux';
import { getPartnerNotesData, PartnerNotesData } from 'store/partnerNotes';

export default function useGetPartnerNote(
  partnerId?: string,
): PartnerNotesData[string] | null {
  const partnerNotesData = useSelector(getPartnerNotesData());

  if (!partnerId || !partnerNotesData) return null;

  return partnerNotesData[partnerId];
}
